import {Component, Host, ViewChild} from '@angular/core';
import {ApiLockersService} from '../../../services/api-directory.service';
import {DirectoryItemComponent} from '../directory-item.component';
import {AbstractView} from '../abstract-view.class';
import {DirectoryService} from '../../../services/directory.service';
import {ResidentForSelect} from '../../../types/data.types';

declare const toastr: any;

@Component({
    templateUrl: 'lockers.template.html',
    providers: [ApiLockersService]
})
export class LockersComponent extends AbstractView {
    @ViewChild('form') form;
    title = 'Locker';
    buildingSelectIsDisabled = false;
    suites = [];
    residents = [];
    formFields = {
        rentedToBuilding:  { editMode: false},
        rentedToSuite:     { editMode: false},
        rentedToSuiteUser: { editMode: false}
    };

    constructor(@Host() parent: DirectoryItemComponent,
                public api: ApiLockersService,
                public directoryService?: DirectoryService) {
        super(parent, api, directoryService);
    }

    resetRentedTo() {
        if (+this.data.rentedOut === 0) this.data.rentedTo = '';
    }

    showChangeUnitModal(data) {
        data.buildingId = data.building;
        data.suiteId = data.suite;
        this.directoryService.showChangeUnitModal(data);
    }

    changeBuilding(buildingId: string) {
        this.form.controls['suite'].reset();
        this.form.controls['suiteUser'].reset();
        this.getSuites(+buildingId, null, this.form);
    }

    getSuites(buildingId: number, suiteId?: number, form?): void {
        if (!buildingId) return;
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.buildingSelectIsDisabled = true;
        this.api.api.get('domainBD', url).subscribe(
            res => {
                this.suites = [];
                const suites = JSON.parse(res._body).entities || [];
                this.suites = suites.map(suite => ({id: suite.id, name: suite.suiteNumber}));
                this.suites.push({id: 0, name: 'Other'});
                if (suiteId)
                    this.getResidents(suiteId, form);
                else if(suiteId === 0)
                    this.residents = [new ResidentForSelect(0, 'Other')];
                this.buildingSelectIsDisabled = false;
            },
            error => {
                this.buildingSelectIsDisabled = false;
                this.api.api.errorHandler(error, 'Failed get suites');
            }
        );
    }

    changeUnit(suiteId: string, form) {
        form.controls['suiteUser'].reset();
        this.getResidents(+suiteId, form);
        if (suiteId + '' === '0') {
            form.controls['suiteUser'].setValue(0);
            setTimeout(() => {
                form.controls['suiteNumber'].reset();
                form.controls['suiteUserName'].reset();
                // this.residents.push(new ResidentForSelect(0, 'Other'));
            }, 0);
        }
    }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    getResidents(suiteId: number, form): void {
        if (!suiteId) {
            this.residents = [new ResidentForSelect(0, 'Other')];
            return;
        }
        const url = `/v1/suite-users/g_emshort.json?expand=user&suite_id=${suiteId}`;
        this.api.api.get('domainBD', url).subscribe(
            res => {
                this.residents = [];
                if(form.value.rentedToSuite !== 0) {
                    const residents = JSON.parse(res._body).entities;
                    this.residents = residents.map(
                        item => (new ResidentForSelect(item.id, item.user.fullName, [], item.user.email))
                    );
                }
                this.residents.push(new ResidentForSelect(0, 'Other'));
            },
            error => this.api.api.errorHandler(error, 'Failed get Residents')
        );
    }

    changeResident(residentId: number) {
        if (!+residentId)
            this.data.extendedRentedTo.suiteUserName = '';
    }

    setEditModeFor(item, fieldName: string, state: boolean) {
        if (!item.isCanEdit) return;
        this.setEditModeForAll(false);
        if(fieldName != 'rentedToBuilding' && fieldName != 'rentedToSuite' && fieldName != 'rentedToSuiteUser')
            this.data.formFields[fieldName].editMode = state;
        else {
            this.data.formFields.rentedToBuilding.editMode = state;
            this.data.formFields.rentedToSuite.editMode = state;
            this.data.formFields.rentedToSuiteUser.editMode = state;
            setTimeout(() => {
                if (state)
                    this.getSuites(this.data.extendedRentedTo.building, this.data.extendedRentedTo.suite, this.form);
            });
        }
    }

    setEditModeForAll(state: boolean) {
        for (const field in this.formFields)
            this.data.formFields[field].editMode = state;
    }

    applyChanges(form) {
        const building = this.directoryService.buildings.find(b => b.id == form.value.building);
        const suite = this.suites.find(s => s.id == form.value.suite);
        const resident = this.residents.find(s => s.id == form.value.suiteUser);
        const data = {
            extendedRentedTo: {
                building:  form.value.building,
                suite:     form.value.suite ? form.value.suite : undefined,
                suiteNumber: form.value.suite && suite ? suite.suiteNumber : (form.value.suiteNumber ? form.value.suiteNumber : undefined),
                suiteUser: form.value.suiteUser && form.value.suiteUser != '0' ? form.value.suiteUser : undefined,
                suiteUserName: form.value.suiteUser && resident ? resident.fullName : (form.value.suiteUserName ? form.value.suiteUserName : undefined),
            }
        };
        this.update(data);
        this.data.extendedRentedTo = {
            building: data.extendedRentedTo.building,
            buildingName: building.name,
            suite: data.extendedRentedTo.suite,
            suiteNumber: data.extendedRentedTo.suiteNumber,
            suiteUser: data.extendedRentedTo.suiteUser,
            suiteUserName: data.extendedRentedTo.suiteUserName,
        };
        this.setEditModeForAll(false);
    }
}




// WEBPACK FOOTER //
// /app/src/app/views/directory-item/lockers/lockers.component.ts